import type { Schema } from "@/shared/components/Form";

/**
 * Схема фильтров для миграций
 */
export const filterSchema: Schema = {
  search: {
    label: "Поиск",
    type: "text" as const,
    placeholder: "Поиск по названию...",
    xs: 12,
    fullWidth: true,
    priority: "primary",
  },
  status: {
    label: "Статус",
    type: "select" as const,
    xs: 12,
    fullWidth: true,
    options: [
      { value: "", label: "Все статусы" },
      { value: "succeeded", label: "Выполнена" },
      { value: "failed", label: "Ошибка" },
      { value: "processing", label: "Выполняется" },
    ],
    priority: "quick",
  },
};
